import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaTag } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination } from "swiper";
import { IoClose, IoCloseCircleOutline } from "react-icons/io5";
import { IoIosArrowBack } from "react-icons/io";
import { FaGlobe, FaFileAlt, FaTwitter, FaCode } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apis from "../services";
import { Radius } from "lucide-react";
import ReactLoading from "react-loading";

SwiperCore.use([Navigation, Pagination]);

const DetailPS = () => {
  const { state } = useLocation();
  const [icoDetails, setIcoDetails] = useState(state?.apiData || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isFavorite, setIsFavorite] = useState(false);
  const [type, setType] = useState(false);

  // useEffect(() => {
  //   if (!state?.apiData) {
  //     setError("Invalid request. No coin data available.");
  //     setLoading(false);
  //     return;
  //   }
  //   setLoading(true);
  //   setIcoDetails(state.apiData);
  //   setIsFavorite(state.apiData.is_favourite === 1);
  //   setType(state.apiData?.type);

  //   setLoading(false);
  // }, [state]);

  useEffect(() => {
    if (!state?.apiData) {
      setError("Invalid request. No coin data available.");
      setLoading(false); // Stop loading if no data
      return;
    }
    setLoading(true); // Start loader
    setTimeout(() => {
      setIcoDetails(state.apiData); // Simulate data fetching
      setIsFavorite(state.apiData.is_favourite === 1);
      setType(state.apiData?.type);
      setLoading(false); // Stop loader once data is set
    });
  }, [state]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          // backgroundColor: "#1a1a1a",
        }}
      >
        <ReactLoading type="spin" color="#be6bed" height={50} width={50} />
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!icoDetails) {
    return <div>No data available</div>;
  }

  const { capsule, overview, rounds, images, links, Ticker } =
    icoDetails.tokenDetails.details;

  const { tokenName, category } = icoDetails.tokenDetails;

  // Handle image click to open slider
  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setIsSliderOpen(true);
  };

  // Close the slider when clicked outside of the image
  const closeSlider = () => {
    setIsSliderOpen(false);
  };

  // fav
  // Favorite toggle function with additional API call
  const userId = localStorage.getItem("userId");

  const handleToggleFavorite = async () => {
    try {
      const favoriteBody = {
        itemId: icoDetails.tokenDetails._id,
        type: type, // Type for the ICO
        userId: userId, // The current user's ID from localStorage
      };

      // Make the API call to toggle favorite
      const favoriteResponse = await apis.favourite(favoriteBody);

      // Show toast with the response message
      if (favoriteResponse.success) {
        toast.success(
          favoriteResponse.message || "Action completed successfully."
        );
      } else {
        toast.error(favoriteResponse.message || "Something went wrong.");
      }

      // Check if the response indicates that the item is now a favorite or not
      setIsFavorite(favoriteResponse.isFavorite); // Assuming API response returns isFavorite as true or false

      if (type === "active") {
        const activeIdResponse = await apis.getactiveId(
          icoDetails.tokenDetails._id
        );

        setIcoDetails(activeIdResponse);

        setIsFavorite(activeIdResponse?.is_favourite === 1);
      } else {
        const activeIdResponse = await apis.getupcomming(
          icoDetails.tokenDetails._id
        );

        setIcoDetails(activeIdResponse);

        setIsFavorite(activeIdResponse?.is_favourite === 1);
      }
    } catch (error) {
      toast.error("Something went wrong, please try again.");
    }
  };

  return (
    <>
      {/* <div className="back-button">
        <Link to={"/private-sale"}>
          <button type="submit">
            <IoIosArrowBack /> Back
          </button>
        </Link>
      </div> */}
      <div
        style={{
          fontFamily: "Arial, sans-serif",
          padding: "20px",
          backgroundPosition: "center",
        }}
      >
        <div style={{ marginBottom: "30px" }}>
          <div
            style={{
              alignItems: "center",
              // display: "flex",
              flexWrap: "wrap",
              paddingTop: "80px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <h1
                style={{
                  fontSize: "28px",
                  margin: "0",
                  fontFamily: "Atmospheric, sans-serif",
                  alignItems: "center",
                  color: "#888",
                }}
              >
                {tokenName || "Project Name"}
              </h1>
              {Ticker && (
                <p style={{ fontSize: "18px", color: "#888" }}>{Ticker}</p>
              )}
            </div>
            <div
              style={{
                // display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              {capsule && (
                <div
                  style={{
                    marginRight: "20px",
                    fontSize: "18px",
                    color: "#555",
                    marginBottom: "10px",
                  }}
                >
                  <FaTag style={{ marginRight: "5px" }} />
                  {capsule}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >
                {links &&
                  links.length > 0 &&
                  links.map((link, index) => {
                    // Determine the icon based on the button label
                    let IconComponent;
                    if (link.name === "Website") {
                      IconComponent = FaGlobe;
                    } else if (link.name === "Whitepaper") {
                      IconComponent = FaFileAlt;
                    } else if (link.name === "Twitter") {
                      IconComponent = FaTwitter;
                    } else if (link.name === "Source") {
                      IconComponent = FaCode;
                    }

                    return (
                      <a
                        key={index}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button
                          style={{
                            height: "25px",
                            width: "100px",
                            backgroundColor: "rgba(190, 107, 237, 1)",
                            color: "white",
                            border: "none",
                            borderRadius: "65px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                          }}
                        >
                          {/* Render the icon if available */}
                          {IconComponent && <IconComponent />}
                          {link.name}
                        </button>
                      </a>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>

        <div className="ps-row-container">
          <div style={{ flex: 2, minWidth: "300px" }}>
            <div style={{ marginBottom: "20px" }}>
              {/* Main Image */}
              {images?.[0] && (
                <div className="ps-detail-display-image">
                  <img
                    src={images[0]}
                    alt={tokenName || "Project"}
                    onClick={() => handleImageClick(0)}
                    style={{
                      width: "80%",
                      height: "auto",
                      cursor: "pointer",
                    }}
                  />
                </div>
              )}

              {/* Displaying image count below the main image */}
              {images && images.length > 1 && (
                <div
                  style={{
                    fontSize: "16px",
                    textAlign: "center",
                    color: "#fff",
                    marginTop: "10px",
                  }}
                >
                  {` 1 / ${images.length}`}
                </div>
              )}
            </div>

            {/* Other Images */}
            {images?.length > 1 && (
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                {images.slice(1).map((image, index) => (
                  <div
                    key={index}
                    style={{ minWidth: "80px", cursor: "pointer" }}
                  >
                    <img
                      src={image}
                      alt={`Project Image ${index + 2}`}
                      onClick={() => handleImageClick(index + 1)}
                      style={{
                        width: "120px",
                        height: "100px",
                        // objectFit: "cover",
                        borderRadius: "20px",
                        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          <div
            style={{
              flex: 1,
              backgroundColor: "rgb(51, 51, 51)",
              borderRadius: "20px",
              padding: "10px",
              color: "white",
              minWidth: "260px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3
                  style={{
                    fontSize: "24px",
                    color: "#fff",
                    margin: "0",
                    marginBottom: "10px",
                  }}
                >
                  Overview
                </h3>
                {/* fav */}
                <button
                  onClick={handleToggleFavorite}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0",
                  }}
                >
                  <img
                    src={isFavorite ? "/likered.svg" : "/unlike.svg"} // use for both like or unlike
                    alt={isFavorite ? "Unlike" : "Like"}
                    style={{
                      width: "22px",
                      height: "22px",
                      marginLeft: "8px",
                      transition: "transform 0.3s ease",
                      // filter: isFavorite ? "brightness(0) saturate(100%) sepia(0) hue-rotate(340deg) saturate(200%)" : "none",
                      transform: isFavorite ? "scale(1.1)" : "scale(1)",
                    }}
                  />
                </button>

                {/* fav */}
              </div>

              {overview?.description && (
                <p style={{ fontSize: "14px", color: "#fff" }}>
                  {overview.description}
                </p>
              )}
            </div>

            <div style={{ marginBottom: "20px" }}>
              {overview?.totalRaised?.amount && (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p style={{ fontSize: "12px", color: "#fff" }}>
                    Total Raised:
                  </p>
                  <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                    {overview.totalRaised.amount}
                  </p>
                </div>
              )}
              {overview?.preValuation?.amount && (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p style={{ fontSize: "12px", color: "#fff" }}>
                    Pre-Valuation:
                  </p>
                  <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                    {overview.preValuation.amount}
                  </p>
                </div>
              )}

              {category && (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p style={{ fontSize: "12px", color: "#fff" }}>Category:</p>
                  <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                    {category}
                  </p>
                </div>
              )}
              {overview?.lastUpdated?.lastupdatedtime && (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p style={{ fontSize: "12px", color: "#fff" }}>
                    Last Updated:
                  </p>
                  <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                    {overview.lastUpdated.lastupdatedtime}
                  </p>
                </div>
              )}
              <div className="ps-detail-content">
                {overview?.marketCap && (
                  <div>
                    <p style={{ fontSize: "12px", color: "#555" }}>
                      Market Cap:
                    </p>
                    <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                      {overview.marketCap}
                    </p>
                  </div>
                )}
                {overview?.fdv && (
                  <div className={overview?.marketCap && "border"}>
                    <p style={{ fontSize: "12px", color: "#555" }}>FDV:</p>
                    <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                      {overview.fdv}
                    </p>
                  </div>
                )}
                {overview?.volume && (
                  <div className={overview?.fdv && "border"}>
                    <p style={{ fontSize: "12px", color: "#555" }}>Volume:</p>
                    <p style={{ fontSize: "12px", fontWeight: "bold" }}>
                      {overview.volume}
                    </p>
                  </div>
                )}
              </div>
            </div>

            {overview["Returns since last round"]?.length > 0 && (
              <div style={{ marginBottom: "20px" }}>
                <h4 style={{ fontSize: "20px" }}>Returns since last round:</h4>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {overview["Returns since last round"].map((item, index) => (
                    <div
                      key={`returns-${index}`}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ fontWeight: "bold" }}>{item.name}:</span>
                      <span>{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          className="heading-head"
          style={{
            fontFamily: "Atmospheric, sans-serif",
            fontWeight: "bold",
            height: "70px",
            width: "100%",
            display: "flex",
            alignItems: "end",
            justifyContent: "center",
            fontSize: "24px",
            color: "#888",
          }}
        >
          All Activities
        </div>

        <div style={{ marginTop: "30px" }}>
          {rounds &&
            rounds.map((round, idx) => (
              <div key={idx} style={{ marginBottom: "20px" }}>
                <div
                  style={{
                    backgroundColor: "rgb(51, 51, 51)",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <h4 style={{ fontSize: "22px", color: "white" }}>
                    {round.roundTitle || "Round Title"}
                  </h4>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      fontFamily: "rubik",
                      color: "white",
                    }}
                  >
                    Round Type: {round.roundType || "Round Type"}
                  </p>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      fontFamily: "rubik",
                      color: "white",
                    }}
                  >
                    Round Date: {round.rounddate || "Date not available"}
                  </p>
                  {round.price && (
                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "rgba(190, 107, 237, 1)",
                      }}
                    >
                      Price:{" "}
                      {round.price && round.price !== "Unknown"
                        ? round.price
                        : "Not Provided"}
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>

        {/* Modal Slider */}

        {isSliderOpen && (
          <div className="ps-detail-image-preview">
            {/* Close Button */}
            <div
              className="close-icon"
              onClick={closeSlider} // Close the modal when clicked
            >
              <IoClose />
            </div>
            <div className="image-slider">
              <Swiper initialSlide={currentImageIndex} navigation={true}>
                {images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <div className="image-preview-container">
                      <img src={image} alt={`Slide ${index}`} />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DetailPS;
